export const n_plus_one = 'n_plus_one';
export const pickup_for_employees = 'pickup_for_employees';
export const late_courier_excuse = 'late_courier_excuse';
export const product_discount = 'product_discount';

export const typePromotions = [
    {
        title: '-',
        value: '',
    },
    {
        title: 'N+1',
        value: n_plus_one,
    },
    {
        title: 'Запізнення курʼєра',
        value: late_courier_excuse,
    },
    {
        title: 'Знижка на товар',
        value: product_discount,
    },
    // {
    //     title: 'Cамовивіз',
    //     value: pickup_for_employees,
    // },
];